// Dodawanie urządzenia do konta (docs/pwa/PLAN-ZROWNANIA.md etap 2; worker-go/api/przypisanie.go): stan numeru przed
// WiFi, przypisanie po parowaniu Bluetooth, wnioski ze zdjęciem ekranu (telefon bez Bluetooth, numer na innym koncie).
// Wnioski poza Reactem jak kolejka egzemplarzy (api/oczekujace.ts): wczytywane przy starcie i po zdarzeniu konta
// `urzadzenia.zmiana` (decyzja admina, nowy wniosek z innego telefonu).
import { useSyncExternalStore } from "react";
import type { AccountEvent, ClaimReply, DeviceRequestOut, DeviceRequestReply, DeviceRequestsReply, SNStateReply } from "../gen/kontrakt";
import { zdjecieBase64 } from "../uklad/zdjecie";
import { zapytanie } from "./zaplecze";

export const stanNumeru = (sn: string) => zapytanie<SNStateReply>("GET", "/api/urzadzenia/numer?sn=" + encodeURIComponent(sn));

/** Przypisanie po parowaniu Bluetooth: odcisk klucza z odczytu INFO urządzenia (dowód, że telefon stoi przy nim). */
export const przypisz = (sn: string, identHash: string) =>
  zapytanie<ClaimReply>("POST", "/api/urzadzenia/przypisz", { sn, ident_hash: identHash });

let lista: readonly DeviceRequestOut[] = [];
const sluchacze = new Set<() => void>();
let wczytywanie: Promise<void> | null = null;

function ustaw(l: readonly DeviceRequestOut[]): void {
  lista = l;
  for (const f of sluchacze) f();
}

/** Wczytuje wnioski konta (jedno zapytanie naraz); błąd - zostaje poprzednia lista. */
export function wczytajWnioski(): Promise<void> {
  wczytywanie ??= zapytanie<DeviceRequestsReply>("GET", "/api/urzadzenia/wnioski")
    .then((o) => ustaw(o.wnioski), () => undefined)
    .finally(() => { wczytywanie = null; });
  return wczytywanie;
}

/** Zdarzenie SSE `konto`: sztuki albo wnioski konta zmienione. */
export function przyjmijZdarzeniePrzypisan(e: AccountEvent): void {
  if (e.rodzaj === "urzadzenia.zmiana") void wczytajWnioski();
}

/** Wylogowanie: bez wniosków poprzedniego konta. */
export function wyczyscWnioski(): void {
  ustaw([]);
}

function subskrybuj(f: () => void): () => void {
  sluchacze.add(f);
  return () => sluchacze.delete(f);
}

export function useWnioski(): readonly DeviceRequestOut[] {
  return useSyncExternalStore(subskrybuj, () => lista);
}

/** Wniosek: numer z naklejki/ekranu i zdjęcie ekranu. Numer na innym koncie serwer zamienia w zgłoszenie przeniesienia. */
export async function wyslijWniosek(sn: string, zdjecie: File): Promise<DeviceRequestReply> {
  const odp = await zapytanie<DeviceRequestReply>("POST", "/api/urzadzenia/wnioski",
    { sn, zdjecie: await zdjecieBase64(zdjecie) });
  await wczytajWnioski();
  return odp;
}
